import React from "react";
import "./Checkboxes.css";

export default function Checkboxes({
  checkedFlag,
  toggleChange,
  criteriaName,
  value,
}) {
  return (
    <div className="checkboxborder">
      <label>
        <input
          type="checkbox"
          value={value}
          checked={checkedFlag}
          onChange={toggleChange}
          disabled
        />
        <span className="checkbox" />
        <span id="fontStyle">{criteriaName}</span>
      </label>
    </div>
  );
}
